export default "__VITE_ASSET__BqNxXdVJ__"